import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// ==============================
// Load mentor list
// ==============================
export const loadMentorList = createAsyncThunk(
  "mentors/loadMentorList",
  async ({ request, domains, user_id, role_id }, { rejectWithValue }) => {
    try {
      const response = await agent.get(
        `${API.LOAD_MENTORS}/${user_id}/${role_id}?userDomains=${domains}`,
        { params: request }
      );

      const data = response?.data?.data?.data || [];
      const pagination = response?.data?.data?.pagination || {};

      return { mentors: data, pagination };
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load mentors"
      );
    }
  }
);

// ==============================
// Save selected mentor
// ==============================
export const saveSelectMentor = createAsyncThunk(
  "mentors/saveSelectMentor",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await agent.post(API.SAVESELECTMENTOR, payload);
      return res.data?.message || "Mentor selected successfully";
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to select mentor");
    }
  }
);

// ==============================
// Get filters (domains)
// ==============================
export const getFilterData = createAsyncThunk(
  "mentors/getFilterData",
  async (_, { rejectWithValue }) => {
    try {
      const res = await agent.get(API.GET_FILTER);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err.message || "Failed to load filters"
      );
    }
  }
);
export const updateUserData = createAsyncThunk(
  "mentors/getFilterData",
  async (_, { rejectWithValue }) => {
    try {
      const res = await agent.get(API.UPDATEUSER);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err.message || "Failed to load filters"
      );
    }
  }
);

// ==============================
// Slice
// ==============================
const dashboardMentorSlice = createSlice({
  name: "dashboardMentor",
  initialState: {
    mentorsData: [],
    filters: [],
    loading: false,
    error: null,
    saveMessage: "",
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(loadMentorList.fulfilled, (state, action) => {
        state.loading = false;
        state.mentorsData = action.payload.mentors;   // array
        state.pagination = action.payload.pagination;
        state.notFound = action.payload.mentors.length === 0;
      })
      .addCase(loadMentorList.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadMentorList.rejected, (state) => {
        state.loading = false;
        state.notFound = true;
      })

      // Save selected mentor
      .addCase(saveSelectMentor.fulfilled, (state, action) => {
        state.saveMessage = action.payload;
      })

      // Filters
      .addCase(getFilterData.fulfilled, (state, action) => {
        state.filters = action.payload;
      });
  },
});

export default dashboardMentorSlice.reducer;
